import { Switch as MUISwitch, SwitchProps } from '@mui/material';

export { type SwitchProps } from '@mui/material';

export function Switch(props: SwitchProps) {
  return <MUISwitch {...props} role="switch" />;
}
